const PRODUCTS = [
  {
    name: 'RaaS Gateway',
    tag: 'API',
    desc: '50+ endpoints for AI mission execution. Multi-model routing, credit billing, webhook integrations.',
    url: 'https://api.agencyos.network/health',
    badge: 'live' as const,
  },
  {
    name: 'Dashboard',
    tag: 'WEB APP',
    desc: 'Real-time analytics, mission tracking, credit management. Your AI operations control center.',
    url: 'https://app.agencyos.network',
    badge: 'live' as const,
  },
  {
    name: 'Mekong CLI',
    tag: 'CLI',
    desc: '342 commands, 6 operational layers. From founder strategy to engineering execution.',
    url: 'https://docs.agencyos.network',
    badge: 'live' as const,
  },
  {
    name: 'AlgoTrade',
    tag: 'TRADING',
    desc: 'AI-powered paper trading with DeepSeek R1. Blind prompt strategy, 14.6% avg edge on M1 Max.',
    url: 'https://docs.agencyos.network',
    badge: 'local' as const,
  },
  {
    name: 'Sophia Factory',
    tag: 'AI FACTORY',
    desc: 'Content generation pipeline. Blog posts, social media, email campaigns — all AI-operated.',
    url: 'https://docs.agencyos.network',
    badge: 'beta' as const,
  },
  {
    name: 'CashClaw',
    tag: 'SIMULATOR',
    desc: 'Task execution simulator with 25+ test scenarios. Validate agent behavior before production.',
    url: 'https://docs.agencyos.network',
    badge: 'beta' as const,
  },
]

const BADGE_CLS = { live: 'badge-live', beta: 'badge-beta', local: 'badge-local' }
const BADGE_LABEL = { live: 'Live', beta: 'Beta', local: 'Local' }

export function EcosystemGrid() {
  return (
    <section className="section">
      <div className="container">
        <h2 className="section-title">The Ecosystem</h2>
        <p className="section-subtitle">
          One platform, many products. Mekong CLI is the sun — these are the planets it powers.
        </p>
        <div className="eco-grid">
          {PRODUCTS.map((p) => (
            <a key={p.name} href={p.url} className="glass eco-card" target="_blank" rel="noopener noreferrer">
              <div className="eco-card-header">
                <h3>{p.name}</h3>
                <span className={`eco-badge ${BADGE_CLS[p.badge]}`}>{BADGE_LABEL[p.badge]}</span>
              </div>
              <span className="eco-tag">{p.tag}</span>
              <p>{p.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  )
}
